import React from 'react';

const FooterV3 = () => {
  return (
    <footer className="w-full bg-slate-950 text-slate-300">
      <div className="max-w-6xl mx-auto px-6 py-24 text-sm flex flex-col sm:flex-row justify-between gap-3">
        <span>© {new Date().getFullYear()} Shalender Kumar</span>
        <span>Portfolio V3</span>
      </div>
    </footer>
  );
};

export default FooterV3;
